"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createScriptNode = void 0;
const createScriptNode = (src, scriptId) => {
    const scriptNode = document.createElement('script');
    scriptNode.src = src;
    scriptNode.async = true;
    if (scriptId) {
        scriptNode.id = scriptId;
    }
    scriptNode.setAttribute('data-status', 'loading');
    document.body.appendChild(scriptNode);
    const setAttributeFromEvent = (event) => {
        const scriptStatus = event.type === 'load' ? 'ready' : 'error';
        scriptNode?.setAttribute('data-status', scriptStatus);
    };
    scriptNode.addEventListener('load', setAttributeFromEvent);
    scriptNode.addEventListener('error', setAttributeFromEvent);
    return scriptNode;
};
exports.createScriptNode = createScriptNode;
